export const CLOSE_SUB_MENU_PANEL_EVENT = 'closeSubMenuDropdownPanelEvent';
